import React from "react";

const Register = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
        textAlign: "center",
        flexDirection: "column",
      }}
    >
      <span style={{ color: "blue" }}>
        Commercial Vehicle Instant Feedback Instant Redressal. For enquiries,
        please write to us at&nbsp;&nbsp;&nbsp;
      </span>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.tatamotors.com/contact-us/"
      >
        https://www.tatamotors.com/contact-us/
      </a>
    </div>
  );
};

export default Register;
